"use client";

import { useState } from "react";

import { BottomRow } from "@/components/audioPlayers/audioPlayerDownloadConversion/BottomRow";
import { Details } from "@/components/audioPlayers/audioPlayerDownloadConversion/Details";
import { DoneConversion } from "@/components/audioPlayers/audioPlayerDownloadConversion/DoneConversion";
import { FailedConversion } from "@/components/audioPlayers/audioPlayerDownloadConversion/FailedConversion";
import { NotDoneConversion } from "@/components/audioPlayers/audioPlayerDownloadConversion/NotDoneConversion";
import {
  ConversionConstructedNoDates,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";
import { getArtistInstrumentModelMixedModel } from "@/utils/artistInstrumentModelMixedModel/get/getArtistInstrumentModelMixedModel";

export function AudioPlayerDownloadConversion({
  conversion,
  models,
  user,
  mixedModelsConstructed,
}: {
  conversion: ConversionConstructedNoDates;
  models: ModelNoDates[] | null;
  user: UserNoDates;
  mixedModelsConstructed: MixedModelConstructedNoDates[] | null;
}) {
  const [open, setOpen] = useState(false);

  const artistInstrumentModelMixedModel = getArtistInstrumentModelMixedModel(
    conversion.voiceId,
    models,
    mixedModelsConstructed
  );

  return (
    <div
      className="rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5"
      data-tutorial={`conversion-${conversion.id}`}
    >
      {conversion.failed && <FailedConversion conversion={conversion} />}

      {!conversion.failed && conversion.confirmedDone && (
        <DoneConversion user={user} conversion={conversion} />
      )}

      {!conversion.failed && !conversion.confirmedDone && (
        <NotDoneConversion conversion={conversion} />
      )}

      <BottomRow
        conversion={conversion}
        artistInstrumentModelMixedModel={artistInstrumentModelMixedModel}
        open={open}
        setOpen={setOpen}
      />

      {open && (
        <Details
          conversion={conversion}
          artistInstrumentModelMixedModel={artistInstrumentModelMixedModel}
        />
      )}
    </div>
  );
}
